<template>
    <div class="col-md-3 mb-sm-3 mb-md-0">
        <b-list-group
            role="tablist"
            class="shadow bg-white h-100 p-b rounded-0"
        >
            <b-list-group-item
                @click="
                    page = 'home';
                    $emit('page', page);
                "
                :class="page == 'home' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Detalhe do Acolhimento
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'primeira';
                    $emit('page', page);
                "
                :class="page == 'primeira' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Primeira Observação
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'caracteristica';
                    $emit('page', page);
                "
                :class="page == 'caracteristica' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Características do Acolhido
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'observacao';
                    $emit('page', page);
                "
                :class="page == 'observacao' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Observação na Visita Familiar
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'objetivo_crianca';
                    $emit('page', page);
                "
                :class="page == 'objetivo_crianca' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Objetivos e Metas - Criança e Adolescente
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'objetivo_responsavel';
                    $emit('page', page);
                "
                :class="page == 'objetivo_responsavel' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Objetivos e Metas - Pais e responsáveis
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'termo';
                    $emit('page', page);
                "
                :class="page == 'termo' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Termo de Compromisso
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'pia';
                    $emit('page', page);
                "
                :class="page == 'pia' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                PIA
            </b-list-group-item>
            <b-list-group-item
                @click="
                    page = 'historicopia';
                    $emit('page', page);
                "
                :class="page == 'historicopia' ? 'active' : ''"
                class="nav-link"
                href="#"
                role="tab"
            >
                Histórico PIA
            </b-list-group-item>
        </b-list-group>
    </div>
</template>
<script>
export default {
    props: ["active"],
    data() {
        return { page: "home" };
    },
    mounted() {
        if (this.active) {
            this.page = this.active;
        }
    },
    methods: {},
};
</script>
